export default {
  trainingClass_recent_released:'最近發布',
  trainingClass_check_train:'1202Web-查看培训班',
  trainingClass_show_train:'1201Web-显示培训班列表',
  trainingClass_portal_train:'12Web-智门户培训班',
  trainingClass_all_months:'全部月份',
  trainingClass_year_mouths:'{year}年{MM}月',
}
